import { render, staticRenderFns } from "./ModalTags.vue?vue&type=template&id=705db018"
import script from "./ModalTags.vue?vue&type=script&lang=js"
export * from "./ModalTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports